import React from "react";

const NotificationContext = React.createContext(null);

export default NotificationContext;
